import { WalletMockService } from "@/services/backend";
import { Button } from "@mantine/core";
import { CheckoutRequest } from "..";
import { randomUUID } from "crypto";
import { useNavigate } from "react-router-dom";
import { AgenticCheckoutService } from "@/services/checkout";

export function AgenticTestCheckoutPage() {
    const navigate = useNavigate();
    const request: CheckoutRequest = {
        merchant: "gymshark.com",
        preid: "testproductid1",
        subtotal: "22.00",
        shipping: "0.00",
        tax: "0.00",
        total: "22.00",
        desc: "crest t-shirt",
        callback: "",
        cid: "",
        productUrl: "https://www.gymshark.com/products/gymshark-crest-t-shirt-ss-tops-brown-ss26",
        items: [{ id: "6580398", amount: "22.00", name: "crest t-shirt", url: "https://www.gymshark.com/products/gymshark-crest-t-shirt-ss-tops-brown-ss26", quantity: 1, merchant: "gymshark.com" }]
    }

    const f21request: CheckoutRequest = {
        merchant: "forever21.com",
        preid: "testproductid1",
        subtotal: "15.00",
        shipping: "0.00",
        tax: "0.00",
        total: "15.00",
        desc: "girl knit sweater",
        callback: "",
        cid: "",
        productUrl: "https://www.forever21.com/products/01335364",
        items: [{ id: "01335364", amount: "15.00", name: "girl knit sweater", url: "https://www.forever21.com/products/01335364", quantity: 1, merchant: "forever21.com" }]
    }

    const f21request2: CheckoutRequest = {
        merchant: "forever21.com",
        preid: "testproductid1",
        subtotal: "7.99",
        shipping: "0.00",
        tax: "0.00",
        total: "7.99",
        desc: "basic cotton v-neck tee",
        callback: "",
        cid: "",
        productUrl: "https://www.forever21.com/products/00489779",
        items: [{ id: "00489779", amount: "7.99", name: "basic cotton v-neck tee", url: "https://www.forever21.com/products/00489779", quantity: 1, merchant: "forever21.com" }]
    }

    //https://www.forever21.com/products/00489779

    const neggrequest: CheckoutRequest = {
        merchant: "newegg.com",
        preid: "testproductid1",
        subtotal: "39.99",
        shipping: "0.00",
        tax: "0.00",
        total: "39.99",
        desc: "Zalman CUBIX-G Micro-ATX PC Case",
        callback: "",
        cid: "",
        productUrl: "https://www.newegg.com/zalman-micro-atx-abs-steel-tempered-glass-cases-computer-cases-atx-form-black-white-cubix-g/p/2AM-0022-000R6",
        items: [{ id: "9SIABW9KRR2623", amount: "39.99", name: "Zalman CUBIX-G Micro-ATX PC Case", url: "https://www.newegg.com/zalman-micro-atx-abs-steel-tempered-glass-cases-computer-cases-atx-form-black-white-cubix-g/p/2AM-0022-000R6", quantity: 1, merchant: "newegg.com" }]
    }
    async function goToGymSCheckout() {
        const id = await AgenticCheckoutService.checkout(request);
        navigate(`/agentic/checkout/${id}`);

    }

    async function goToF21Checkout() {
        const id = await AgenticCheckoutService.checkout(f21request);
        navigate(`/agentic/checkout/${id}`);

    }

    async function goToNewECheckout() {
        const id = await AgenticCheckoutService.checkout(neggrequest);
        navigate(`/agentic/checkout/${id}`);

    }
    return (
        <>
            <Button onClick={goToGymSCheckout}>Go To Gym Shark Checkout</Button>
            <Button onClick={goToF21Checkout}>Go To F21 Checkout</Button>
            <Button onClick={goToNewECheckout}>Go To New Egg Checkout</Button>
        </>
    )
}